/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Chatbot } from '../models/Chatbot';
import type { FeaturesResult } from '../models/FeaturesResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FeatureService {

    /**
     * @param featureId
     * @param organizationId
     * @returns Chatbot OK
     * @throws ApiError
     */
    public static getChatbot(
        featureId: string,
        organizationId: string,
    ): CancelablePromise<Chatbot> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/features/{organizationId}/{featureId}/chatbot',
            path: {
                'featureId': featureId,
                'organizationId': organizationId,
            },
        });
    }

    /**
     * Retrieve all features that belongs to an organization.
     * @param organizationId The ID of the organization.
     * @returns FeaturesResult OK
     * @throws ApiError
     */
    public static getFeatures(
        organizationId: string,
    ): CancelablePromise<Array<FeaturesResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/features/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
